export const getInitials = (name?: string): string | undefined => {
    if (!name?.trim()) {
        return;
    }

    const words = name
        .trim()
        .split(" ")
        .filter((word) => word.length > 0);

    if (words.length === 0) {
        return;
    }

    if (words.length === 1) {
        return words[0].charAt(0).toUpperCase();
    }

    const firstInitial = words[0].charAt(0).toUpperCase();
    const lastInitial = words[words.length - 1].charAt(0).toUpperCase();

    return `${firstInitial}${lastInitial}`;
};
